import { Col, DatePicker, Form, Row } from 'antd'
import CustomSpin from '../../../../../../elements/CustomSpin'
import FormSectionTitle from '../../../../../../elements/FormSectionTitle'
import withSpinning from '../../../../../../elements/HOC/withSpinning'
import CustomDebounceSelect from '../../../../../../elements/Select/CustomDebounceSelect'
import OrganisationsSelect from '../../../../../../elements/Select/Organistaions'
import withUrlFetch from '../../../../../../elements/Select/withUrlFetch'
import { rules, threeFormItemLayout } from '../../../../../../modules/FormItems'
import moment from 'moment'
import React from 'react'

import { compose } from 'recompose'

const VendorSelect = compose(
  withUrlFetch({
    name: 'suppliers',
    url: `/suppliers`,
  }),
  withSpinning,
)(CustomDebounceSelect)

function VendorForm(props) {
  const { submitting } = props
  const { getFieldDecorator } = props.form

  return (
    <CustomSpin spinning={submitting}>
      <Form>
        <FormSectionTitle title={'Details'} />
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Start'}>
              {getFieldDecorator('start', {
                initialValue: moment('01-01-2021'),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} placeholder="Start" />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'End'}>
              {getFieldDecorator('end', {
                initialValue: moment(),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} placeholder="End" />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Company">
              {getFieldDecorator('company')(<OrganisationsSelect />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomSpin>
  )
}

VendorForm.propTypes = {}
VendorForm.defaultProps = {
  selection: [],
}

export default Form.create()((VendorForm))
